angular.module('BGEHeroes.services.LoaderSvcLepes1', [])

.service('loaderSvcLepes1', [ 'Gateway',  function (Gateway) {
   var manifest = [ 
       {src: "lepes1/hatter1.png", id: "hatter1"},
       {src: "lepes1/fej1.png", id: "fej1"},
       {src: "lepes1/fej2.png", id: "fej2"},
       {src: "lepes1/fej3.png", id: "fej3"},
       {src: "lepes1/fej4.png", id: "fej4"},
       {src: "lepes1/lampas.png", id: "lampas"},
       {src: "lepes1/keret.png", id: "keret"},
       {src: "kozos/jobbra.png", id: "jobbra"},
       {src: "kozos/balra.png", id: "balra"},
       {src: "kozos/logo.png", id: "logo"},
       {src: "kozos/bar.png", id: "bar"},
       {src: "kozos/tovabb.png", id: "tovabb"},
       {src: "kozos/ujra.png", id: "ujra"},
	   {src: "kozos/ablak_nagy.png", id: "ablak_nagy"},

       {src: "kozos/kihagy.png", id: "kihagy"},
	   {src: "kozos/tipp.png", id: "tipp"},
	   ];
   
   loader = new createjs.LoadQueue(false);
   
   this.getResult = function (asset) {
       return loader.getResult(asset);
   };
   this.getLoader = function () {
       return loader;
   };
   this.loadAssets = function () {  
		loader.loadManifest(manifest, true, Gateway.cordovaprefix + "/images/");
   };
}]);